import { ShippingMethod } from '../models/step-shipping/shipping-methods.js';

/**
 * Shipping method helpers
 */ const isDelivery = (method)=>method === ShippingMethod.Delivery
;
const isDeliveryExpress = (method)=>method === ShippingMethod.DeliveryExpress
;
const isNearestPickup = (method)=>method === ShippingMethod.NearestPickup
;
const isPickupStore = (method)=>method === ShippingMethod.Pickup
;
const isPickupPoint = (method)=>method === ShippingMethod.PickupPoint
;
const isDeliveryPremium = (method)=>method === ShippingMethod.DeliveryPremium
;

export { isDelivery, isDeliveryExpress, isDeliveryPremium, isNearestPickup, isPickupPoint, isPickupStore };
//# sourceMappingURL=shipping-method.js.map
